import {useState} from "react"

export const useViewMoreText = ({characterLimit, text}: { characterLimit: number, text: string }) => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const visibleText = expanded ? text : text.slice(0, characterLimit);
    return {
        expanded,
        visibleText: visibleText,
        showToggle: text.length > characterLimit,
        toggle: () => setExpanded(!expanded)
    }
}